"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inverseSigmoid = exports.sigmoid = void 0;
function sigmoid(z) {
    return Math.pow(1 + Math.exp(-z), -1);
}
exports.sigmoid = sigmoid;
function inverseSigmoid(z) {
    const x = Math.min(Math.max(z, 0.01), 0.99);
    return Math.log(x / (1 - x));
}
exports.inverseSigmoid = inverseSigmoid;
